import React from 'react';
import { WaitLoader } from './WaitLoader';

export type ThinkingAnimationProgressLabel = {
    current: number;
    total: number;
    /** Text after the counts, e.g. "topics added so far". */
    suffix?: string;
};

interface ThinkingAnimationProps {
    message?: string;
    /** Secondary reassurance line under the progress bar when no step list is shown. */
    secondary?: string;
    /**
     * Stable "{current} of {total} …" line — only `current` updates; suffix and dots do not re-type.
     */
    progressLabel?: ThinkingAnimationProgressLabel;
    /** Ordered pipeline steps for unit creation / regeneration loaders. */
    progressSteps?: readonly string[];
    currentProgressStepIndex?: number;
}

/**
 * Blocking-wait body using WaitLoader. Keep message/progressLabel API for existing call sites.
 */
export function ThinkingAnimation({
    message = 'Thinking',
    secondary = 'This may take a few moments...',
    progressLabel,
    progressSteps,
    currentProgressStepIndex = 0
}: ThinkingAnimationProps) {
    const title = progressLabel
        ? `${progressLabel.current} of ${progressLabel.total} ${progressLabel.suffix ?? 'topics added so far'}`
        : message;

    return (
        <WaitLoader
            title={title}
            secondary={secondary}
            steps={progressSteps}
            currentStepIndex={currentProgressStepIndex}
        />
    );
}
